import { PageParameter } from '@pulseops/common'

export namespace SuspendTask {
  export interface InputData {
    suspended: boolean
    category: string
    pagination: PageParameter
  }
}
